/**
 * 공개 사이트 공통 틀(머리말·푸터·바로가기) 문구 — `landing` 네임스페이스의 `site` 아래에 합쳐진다.
 * 페이지 본문 문구는 페이지별 파일(`landingPages.ts`·`landingManual.ts`·`landingReleases.ts`)에 둔다.
 */
const landingSite = {
  "skipToContent": "본문 바로가기",
  "homeLabel": "DroneSquare 홈",
  "nav": {
    "label": "주 메뉴",
    "mobileLabel": "모바일 메뉴",
    "openMenu": "메뉴 열기",
    "closeMenu": "메뉴 닫기",
    "services": "서비스",
    "plans": "이용 플랜",
    "inquiry": "1:1 문의",
    "news": "언론보도",
    "manual": "매뉴얼",
    "releases": "업데이트 소식"
  },
  "servicePanel": {
    "platform": {
      "title": "플랫폼",
      "description": "2D·3D·4D 점검, 단면·토공, 현장 기록과 관제"
    },
    "survey": {
      "title": "드론 측량 및 공간 데이터 가공",
      "description": "비행 승인부터 정사영상·DSM·3D 모델·수치지형도까지"
    },
    "more": "자세히 보기 →"
  },
  "account": {
    "login": "로그인",
    "start": "시작하기",
    "logout": "로그아웃",
    "flightHub": "드론 관제 시스템 접속",
    "flightHubFailed": "드론 관제 시스템에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요."
  },
  "share": {
    "label": "공유",
    "menuLabel": "공유하기",
    "copied": "링크 복사",
    "failed": "링크를 복사하지 못했습니다."
  },
  "footer": {
    "menuLabel": "푸터 메뉴",
    "company": "회사소개",
    "terms": "이용약관",
    "privacy": "개인정보 처리방침",
    "contact": "제휴/이용 문의",
    "companyName": "(주)알티비온",
    "businessNumber": "사업자등록번호: 146-81-03772",
    "address": "05836 서울특별시 송파구 문정동 640 케이디유타워 제7층 707호",
    "telLabel": "대표전화",
    "hours": "운영시간 : 10:00 - 18:30 · 점심시간 : 12:00 - 13:30",
    "closed": "토요일, 일요일, 공휴일 휴무",
    "copyright": "Copyright © ALTIVION Inc. All rights reserved."
  },
  "contact": {
    "telLabel": "대표전화",
    "hoursLines": ["운영시간 : 10:00 - 18:30", "점심시간 : 12:00 - 13:30", "토요일, 일요일, 공휴일 휴무"],
    "inquiry": "문의하기"
  },
  "sectionIndex": "구역 이동",
  "sectionIndexItem": "{{n}}번째 구역",
  "flow": {
    "label": "드론 매핑 진행 순서",
    "steps": [
      {
        "title": "비행 승인",
        "text": "비행 구역과 고도를 확인하고, 관련 법규에 따라 비행과 촬영 승인을 받습니다.",
        "alt": "항공 구역도 위에서 비행할 공역 경계를 손가락으로 짚어 확인하는 모습"
      },
      {
        "title": "촬영 계획\u00a0· 자동 비행",
        "text": "현장 범위와 필요한 해상도에 맞춰 비행 경로와 사진 중복도를 정하고 자동 비행으로 촬영합니다.",
        "alt": "파란 하늘을 나는 촬영용 드론"
      },
      {
        "title": "GCP 측량",
        "text": "지상 기준점(GCP)을 설치하고 측량해 결과물의 위치 정확도를 높입니다.",
        "alt": "삼각대 위의 GNSS 측량기와 바닥의 GCP 표지, 옆에서 태블릿으로 좌표를 받는 측량자"
      },
      {
        "title": "이미지\u00a0· 영상 취득",
        "text": "계획한 경로를 따라 비행하며 현장 사진과 영상을 촬영합니다.",
        "alt": "드론으로 찍은 고속도로 인터체인지"
      },
      {
        "title": "정사영상\u00a0· DSM\u00a0· 3D 모델 처리",
        "text": "촬영한 사진을 정합해 Point Cloud와 정사영상, DSM, 3D 모델을 만듭니다.",
        "alt": "드론 사진으로 만든 토공 현장 3D 모델. 깎인 비탈과 평탄지가 입체로 보인다."
      },
      {
        "title": "플랫폼",
        "text": "정사영상·3D 모델을 드론스퀘어 플랫폼에 올려 지도 위에서 보고 측정합니다.",
        "alt": "DroneSquare 앱 마크"
      }
    ]
  },
  "education": {
    "eyebrow": "교육 · 컨설팅 · 법규 · 안전",
    "title": "드론 운용부터 SW 활용까지,<br/>현장에 맞춰 함께합니다",
    "photoAlt": "DRONE SQUARE 조끼를 입은 컨설턴트가 등고선 도면 위의 현장을 짚으며 노트북과 태블릿의 드론 지도를 함께 보는 모습",
    "cards": [
      {
        "kicker": "교육",
        "title": "현장 맞춤형 교육",
        "text": "드론운용부터 SW활용까지 현장 맞춤형 교육으로 업무 적용력을 높입니다.",
        "alt": "안전모와 조끼를 입은 교육생들이 현장 탁자에 둘러서서 노트북의 지도와 도면 자료를 보며 교육받는 모습"
      },
      {
        "kicker": "컨설팅",
        "title": "최적의 드론 활용 방안",
        "text": "프로젝트 특성에 맞는 최적의 드론 활용 방안과 실행 전략을 제공합니다.",
        "alt": "DRONE SQUARE 조끼를 입은 컨설턴트가 등고선 도면 위의 현장을 짚으며 노트북과 태블릿의 드론 지도를 함께 보는 모습"
      },
      {
        "kicker": "법규",
        "title": "비행과 측량 관련 법규 준수",
        "text": "드론 비행 및 측량 관련 법규를 준수해 안전하고 법률적인 서비스를 제공합니다.",
        "alt": "클립보드 서류에 내용을 적는 작업자의 손"
      },
      {
        "kicker": "안전 교육",
        "title": "작업자 안전을 위한 지침",
        "text": "드론 활용 시 작업자 안전을 위한 체계적인 교육과 지침을 제공합니다.",
        "alt": "안전모, 장갑, 귀마개, 보안경"
      }
    ]
  },
  "partners": {
    "title": "함께하는 협력사",
    "logos": [
      "수성엔지니어링",
      "태영건설",
      "현대건설",
      "SK에코엔지니어링",
      "우대E&P",
      "K water Tech",
      "풍림산업",
      "활림건설",
      "한국어촌어항공단",
      "HJ중공업",
      "Liberaware"
    ]
  },
  "rows": {
    "pfLayers": {
      "kicker": "단면 레이어",
      "title": "촬영일과 레이어를 골라 겹치기",
      "text": "단면 그래프의 레이어 목록에서 촬영일별 지반선과 DXF 계획선, BIM을 켜고 끄며 한 그래프에서 비교합니다.",
      "alt": "실제 단면 그래프와 레이어 목록. 세 촬영일의 메시 레이어를 골라 켜는 모습."
    },
    "earthwork": {
      "kicker": "선형·구역 기반 토공량",
      "title": "구역만 그리면 토공량을 촬영일마다 계산",
      "text": "깎아 낸 흙(절토)과 채운 흙(성토)의 양을 촬영일마다 자동으로 구합니다. 계획 물량 대비 얼마나 진행됐고 얼마나 남았는지 표 하나로 보고, CSV로 내려받을 수 있습니다.",
      "alt": "실제 토공 화면의 토공 집계표. 흙깎기·흙쌓기를 성상별로 나눠 계획 수량, 잔여토공량, 일자별 누계, 촬영일별 진행 물량을 보여 준다."
    },
    "measure": {
      "kicker": "2D/3D 측정",
      "title": "길이·면적·체적을 화면에서 바로",
      "text": "지점을 찍으면 좌표와 높이가, 여러 점을 이으면 구간마다 길이가 나옵니다. 영역을 그리면 비탈까지 반영한 면적과 체적도 바로 알 수 있습니다.",
      "alt": "실제 3D 화면에서 평탄 부지에 면적 측정을 한 모습(측정 부분 확대). 가운데 칩에 입체 면적 1330.57 m²와 평면 면적 1328.98 m²가, 변마다 길이가 표시된다."
    },
    "issue": {
      "kicker": "이슈",
      "title": "이슈를 그 자리에 남기고 촬영일마다 확인",
      "text": "점·선·영역으로 이슈를 표시하고 내용과 상태를 기록합니다. 촬영일을 바꿔 가며 같은 이슈 자리의 변화를 봅니다.",
      "alt": "실제 2D 화면에서 선택한 사면 토사 유실 이슈 영역과, 왼쪽 이슈 정보 패널의 촬영일·이슈 강도 추이·이슈 정보가 보인다."
    },
    "geolog": {
      "kicker": "사진 · 영상",
      "title": "찍은 자리에 모이는 현장 사진과 영상",
      "text": "현장에서 찍은 사진과 영상을 올리면 위치마다 마커로 모이고, 마커를 누르면 그 자리에서 바로 열어 봅니다.",
      "alt": "실제 2D 화면에서 왼쪽 사진·영상 패널과, 지도 위 마커를 눌러 연 영상 기록 카드가 보인다."
    },
    "pano": {
      "kicker": "360°",
      "title": "360° 사진으로 현장 안까지",
      "text": "360° 사진을 올리면 찍은 자리에서 둘러보듯 현장 안을 확인합니다.",
      "alt": "실제 앱의 360° 보기 화면 전체. 공사 중인 건물 내부와 위치 미니맵, 사진 넘김(1/3)·2D 전환 단추가 보인다."
    },
    "equip": {
      "kicker": "장비 동선 시뮬레이션",
      "title": "장비 동선과 작업반경 겹침을 미리",
      "text": "작업현황 3D에서 장비를 배치하고 동선을 그리면, 재생하는 동안 장비가 움직이고 작업반경이 겹치는 곳에 위험 표시가 나타납니다.",
      "alt": "실제 작업현황 3D 화면에서 굴삭기 두 대가 서로 반대 방향 동선으로 엇갈려 지나가며 작업반경이 겹치는 순간 위험 영역이 표시되고, 덤프트럭이 그 사이를 북쪽으로 가로지른다."
    }
  },
  "scenes": {
    "view": {
      "eyebrow": "2D · 3D · 4D",
      "title": "평면에서 입체로, 그리고 시간까지",
      "lead": "드론으로 찍은 현장을 2D 정사영상과 3D 모델로 확인하고,<brd/> 화면을 4개까지 나눠 촬영일별로 비교하세요.",
      "stepsLabel": "보기 단계",
      "steps": [
        {
          "k": "2D 정사영상",
          "d": "드론 사진으로 만든 고해상도 지도"
        },
        {
          "k": "3D 모델",
          "d": "같은 현장을 3D 화면으로 전환"
        },
        {
          "k": "4D 시계열",
          "d": "화면을 4개로 나눠 촬영일별 비교"
        }
      ],
      "viewLabel": "실제 드론 데이터로 만든 토공 현장. 정사영상 지도를 3D 화면으로 전환한 뒤, 화면을 4개로 나눠 2025년 3월부터 2026년 3월까지 네 촬영일의 공사 진행을 비교한다."
    },
    "bridge": {
      "eyebrowLanding": "측량 · 토공 · 용지",
      "eyebrowPlatform": "측량 · 단면 · 토공",
      "title": "선 하나 그으면, 땅과 구조물 속까지",
      "lead": "3D 화면에 선을 그으면 지형과 BIM을 함께 자른 단면이 그려집니다.<brd/> 시계열로 겹쳐 보고 TXT·CSV·DXF로 바로 내보내세요.",
      "stepsLabel": "단면 단계",
      "steps": [
        {
          "k": "종단면",
          "d": "교량 축을 따라 선을 그으면 바로 단면으로"
        },
        {
          "k": "횡단면",
          "d": "교각 위치를 가로질러 그은 단면"
        },
        {
          "k": "시계열 겹쳐 보기",
          "d": "촬영일별 지반선에 DXF·BIM 레이어까지 한 그래프에"
        },
        {
          "k": "내보내기",
          "d": "점 간격을 정해 TXT·CSV·DXF로"
        }
      ],
      "viewLabel": "실제 교량 공사 현장 3D 모델 위에 교량 BIM(거더·슬래브·교각·교대)을 겹친 화면. 교량 축을 따라 선을 그으면 아래 종단면 그래프에 지반선과 교량 단면이 함께 그려지고, 교각 위치의 횡단면과 두 촬영일 지반선을 겹친 시계열 비교, 점 간격 데이터 추출(TXT·CSV·DXF)까지 이어진다.",
      "lon": "종단면",
      "crs": "횡단면",
      "capture": "이미지 캡처",
      "extract": "점 간격 추출",
      "popTitle": "데이터 추출",
      "popSpacing": "점 간격",
      "popUnit": "m",
      "dateNow": "2026.03.20",
      "datePast": "2025.11.21",
      "bim": "교량 BIM",
      "distance": "거리 (m)",
      "height": "높이 (m)"
    },
    "layers": {
      "eyebrow": "레이어 중첩",
      "title": "모든 데이터를 한 번에",
      "lead": "설계 도면과 지적, 현장 기록을 한 3D 화면에 겹쳐 보고<brd/> 작업현황 3D에서 인원과 장비의 위험까지 미리 확인하세요.",
      "stepsLabel": "레이어 단계",
      "steps": [
        {
          "k": "DXF · 지적 GIS",
          "d": "계획 노선과 필지 경계를 3D 현장 위에"
        },
        {
          "k": "BIM",
          "d": "구조물 BIM을 현장 지형과 함께"
        },
        {
          "k": "Point Cloud",
          "d": "현장을 점 데이터 그대로"
        },
        {
          "k": "벡터",
          "d": "땅속 관로를 볼륨 선으로"
        },
        {
          "k": "클리핑",
          "d": "상자로 잘라 땅속 단면까지"
        },
        {
          "k": "현장 기록",
          "d": "이슈·사진·영상·360°를 위치마다"
        },
        {
          "k": "인원 · 장비 시뮬레이션",
          "d": "작업반경과 동선 위험을 미리"
        }
      ],
      "viewLabel": "실제 드론 데이터로 만든 토공 현장 3D 화면. 설계 노선과 지적 경계, 옹벽 BIM, 점군, 땅속 관로(볼륨 선), 박스 클리핑 단면, 이슈와 현장 사진 위치를 차례로 겹친 뒤, 작업현황 3D 화면에서 굴삭기와 덤프트럭이 그려 둔 동선을 따라 움직이고, 두 굴삭기의 작업반경이 겹치는 순간 위험 영역이 표시된다.",
      "wallBim": "옹벽 BIM",
      "waterPipe": "상수관",
      "stormPipe": "우수관",
      "issues": [
        "사면 토사 유실",
        "배수로 막힘",
        "성토부 균열"
      ]
    },
    "dates": {
      "main": "2026년 03월 20일",
      "panes": [
        "2025년 03월 14일",
        "2025년 07월 18일",
        "2025년 11월 21일",
        "2026년 03월 20일"
      ]
    }
  }
} as const;

export default landingSite;
